import React, { useEffect, useState } from 'react';
import { StyledDiv, StyledSpan } from '../../Theme/CommonStyled';
import { StyledFilter } from '../Credits/style';
import Icon from '../Common/Icon';
import { creditHistoryOptions } from '../../Utils/credits.util';
import ActionSheet from '../Common/ActionSheet';
import RadioGroup from '../Common/RadioGroup';
import { useNavigate } from 'react-router';
import CreditsList from '../Credits/CreditsList';
import useCreditsStore from '../../Store/Credits';
import useLandingStore from '../../Store/Landing';

const CreditHistory: React.FC = () => {
  const navigate = useNavigate();
  const landingData = useLandingStore((state) => state.landingData);
  const [openActionSheet, setOpenActionSheet] = useState(false);

  const setDataLength = useCreditsStore((state) => state.setDataLength);
  const selectedHistoryList = useCreditsStore(
    (state) => state.selectedHistoryList
  );
  const setSelectedHistoryList = useCreditsStore(
    (state) => state.setSelectedHistoryList
  );

  useEffect(() => {
    !selectedHistoryList && setSelectedHistoryList(creditHistoryOptions[0]);
  }, []);

  return (
    <>
      <ActionSheet
        id={'history'}
        footer={false}
        open={openActionSheet}
        onDismiss={() => setOpenActionSheet(false)}>
        <RadioGroup
          layout="vertical"
          options={creditHistoryOptions}
          defaultCheckedRadio={selectedHistoryList}
          onChange={(value) => {
            setDataLength(10);
            setSelectedHistoryList(value);
            setOpenActionSheet(false);
          }}
        />
      </ActionSheet>
      <StyledDiv pt={12} px="15px" direction="rtl">
        <StyledFilter onClick={() => setOpenActionSheet(true)} mb={9}>
          <Icon name="control" fontSize={10} ml={5} color="normalText" />
          <StyledSpan>{selectedHistoryList?.label}</StyledSpan>
        </StyledFilter>
        <CreditsList
          branchId={landingData?.branchId}
          listType={selectedHistoryList?.value as string}
          sortOrder={'HighestCredit'}
        />
      </StyledDiv>
    </>
  );
};

export default CreditHistory;
